import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { BrandMark } from "./Brand";
import { Button } from "./ui/button";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from "./ui/dropdown-menu";
import { Menu, X, ChevronDown, Scale, Briefcase, Phone } from "lucide-react";
import { BUSINESS_CONTACT as BC } from "../data/content";

const NAV_LINKS = [
  { to: "/how-it-works", label: "How it works" },
  { to: "/for-attorneys", label: "For attorneys" },
  { to: "/about", label: "About" },
  { to: "/states", label: "States" },
  { to: "/faq", label: "FAQ" },
  { to: "/blog", label: "Blog" },
];

export default function Navbar() {
  const { pathname } = useLocation();
  const [open, setOpen] = useState(false);
  const onDark = pathname === "/";

  return (
    <header
      className={`sticky top-0 z-40 w-full backdrop-blur-xl border-b ${
        onDark ? "bg-white/70 border-black/5" : "bg-white/95 border-[#E5E7EB]"
      }`}
      data-testid="navbar"
    >
      <div className="mx-auto max-w-7xl px-6 lg:px-10 h-16 flex items-center justify-between">
        <Link to="/" data-testid="nav-home" onClick={() => setOpen(false)}><BrandMark /></Link>

        <nav className="hidden lg:flex items-center gap-7 text-sm text-[#374151]">
          {NAV_LINKS.map((l) => (
            <Link key={l.to} to={l.to} className={`hover:text-[#0A2540] transition-colors ${pathname === l.to ? "text-[#0A2540] font-medium" : ""}`} data-testid={`nav-link-${l.to.replace("/", "")}`}>
              {l.label}
            </Link>
          ))}
        </nav>

        <div className="hidden lg:flex items-center gap-2">
          <DropdownMenu>
            <DropdownMenuTrigger asChild>
              <Button variant="ghost" className="text-[#0A2540] hover:bg-[#F9FAFB] flex items-center gap-1" data-testid="nav-signin-btn">
                Sign in <ChevronDown className="w-3.5 h-3.5" />
              </Button>
            </DropdownMenuTrigger>
            <DropdownMenuContent align="end" className="w-64">
              <DropdownMenuItem asChild>
                <Link to="/attorney-login" className="flex items-start gap-3 py-2.5" data-testid="nav-signin-attorney">
                  <Scale className="w-4 h-4 text-[#0066FF] mt-0.5" />
                  <div>
                    <div className="font-medium text-[#0A2540]">Attorney portal</div>
                    <div className="text-xs text-[#6B7280]">Manage your firm's cases</div>
                  </div>
                </Link>
              </DropdownMenuItem>
              <DropdownMenuItem asChild>
                <Link to="/login" className="flex items-start gap-3 py-2.5" data-testid="nav-signin-admin">
                  <Briefcase className="w-4 h-4 text-[#0066FF] mt-0.5" />
                  <div>
                    <div className="font-medium text-[#0A2540]">Underwriter portal</div>
                    <div className="text-xs text-[#6B7280]">Internal team access</div>
                  </div>
                </Link>
              </DropdownMenuItem>
            </DropdownMenuContent>
          </DropdownMenu>
          <Link to="/apply">
            <Button className="btn-primary-navy rounded-full px-5 h-10" data-testid="nav-apply-btn">Apply now</Button>
          </Link>
        </div>

        <button className="lg:hidden p-2" onClick={() => setOpen(!open)} aria-label="Menu" data-testid="nav-mobile-toggle">
          {open ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
        </button>
      </div>

      {open && (
        <div className="lg:hidden border-t border-[#E5E7EB] bg-white" data-testid="nav-mobile-menu">
          <div className="px-6 py-4 space-y-1">
            {NAV_LINKS.map((l) => (
              <Link key={l.to} to={l.to} onClick={() => setOpen(false)} className="block py-3 text-[#374151] hover:text-[#0A2540] border-b border-[#F3F4F6]">
                {l.label}
              </Link>
            ))}
            <Link to="/attorney-login" onClick={() => setOpen(false)} className="block py-3 text-[#374151] hover:text-[#0A2540] border-b border-[#F3F4F6]">
              Attorney portal
            </Link>
            <Link to="/login" onClick={() => setOpen(false)} className="block py-3 text-[#374151] hover:text-[#0A2540] border-b border-[#F3F4F6]">
              Underwriter portal
            </Link>
            <a href={BC.tel} className="flex items-center gap-2 py-3 text-[#0A2540] font-medium border-b border-[#F3F4F6]" data-testid="nav-mobile-phone-link">
              <Phone className="w-4 h-4 text-[#0066FF]" /> Call {BC.phoneDisplay}
            </a>
            <div className="pt-4">
              <Link to="/apply" onClick={() => setOpen(false)}>
                <Button className="btn-primary-navy w-full">Apply now</Button>
              </Link>
            </div>
          </div>
        </div>
      )}
    </header>
  );
}
